import type { MouseEvent, ReactNode } from 'react';

export type TagTone = 'neutral' | 'ai' | 'primary';

export interface TagProps {
  children?: ReactNode;
  /** neutral = mono chip · ai = terracotta auto-tag · primary = selected filter */
  tone?: TagTone;
  dashed?: boolean;
  onRemove?: () => void;
  onClick?: () => void;
}

interface ToneStyle {
  color: string;
  border: string;
  bg: string;
}

const TONES: Record<TagTone, ToneStyle> = {
  neutral: { color: 'var(--text-2)', border: '1px solid var(--line-strong)', bg: 'transparent' },
  ai: { color: 'var(--amber-ink)', border: '1px solid var(--amber-line)', bg: 'var(--amber-tint)' },
  primary: { color: 'var(--primary)', border: '1px solid var(--line-primary)', bg: 'var(--primary-tint)' },
};

export function Tag({ children, tone = 'neutral', dashed = false, onRemove, onClick }: TagProps) {
  const t = TONES[tone];
  const handleRemove = (e: MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    onRemove?.();
  };
  return (
    <span
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontFamily: 'var(--font-mono)',
        fontSize: 10.5,
        color: t.color,
        background: t.bg,
        border: dashed ? '1px dashed var(--line-strong)' : t.border,
        borderRadius: 7,
        padding: '4px 9px',
        cursor: onClick || onRemove ? 'pointer' : 'default',
        whiteSpace: 'nowrap',
      }}
    >
      {children}
      {onRemove && (
        <span onClick={handleRemove} style={{ opacity: 0.7 }}>
          ×
        </span>
      )}
    </span>
  );
}
